<template>
  <div
    v-if="
      relatedAndAlternativeProducts && sliders.length && status !== 'pending'
    "
  >
    <page-section
      v-for="slider in sliders"
      :key="slider.title"
      :title="{
        displayText: $t(slider.title),
        __component: StrapiComponentType.link,
      }"
      class="additional-products-wrapper !px-0"
    >
      <catalog-products-slider
        class="additional-products"
        :products="slider.products"
        :analytics-data="{
          list: $t(slider.title),
        }"
      />
    </page-section>
  </div>
</template>
<script setup lang="ts">
import type { ProductRelatedAndAlternativeProducts } from "~/types/product";
import { StrapiComponentType } from "~/types/strapi";

const props = defineProps<{
  sku: string;
}>();

const { products } = useMagentoSdk();

const { data: relatedAndAlternativeProducts, status } = useCachedAsyncData(
  "related-upsell-products-" + props.sku,
  async () => {
    const response = await products(
      {
        filter: {
          sku: {
            eq: props.sku,
          },
        },
      },
      {
        customQuery: {
          products: "productRelatedAndAlternativeProducts",
        },
      },
    );

    if (response.data.products?.items?.[0]) {
      return response.data.products
        ?.items?.[0] as any as ProductRelatedAndAlternativeProducts;
    }
  },
);

const sliders = computed(() =>
  relatedAndAlternativeProducts.value
    ? Object.entries(relatedAndAlternativeProducts.value)
        .filter(([_, value]) => Array.isArray(value))
        .filter(([_, value]) => value?.length)
        .map(([key, value]) => ({
          title: key,
          products: value,
        }))
    : [],
);
</script>
<style lang="scss" scoped>
.additional-products {
  &:deep(.products-slider__navigations) {
    @apply absolute right-4 top-8 sm:right-5 sm:top-7 lg:right-10 lg:top-[72px];
  }
  &:deep(.products-slider__navigations-wrapper) {
    @apply flex justify-end;
  }
  &-wrapper {
    @apply relative;

    &:deep(.page-section-top) {
      @apply pb-8 sm:pb-7 sm:pt-10 lg:pb-10 lg:pt-[72px];
    }
  }
}
</style>
